<script setup lang="ts">
import type { SoMeIcon } from 'types';

defineProps<{
  icons: SoMeIcon[];
}>();
</script>

<template>
  <ul
    class="flex justify-center gap-6 text-white lg:justify-start lg:gap-8"
    :aria-label="$t('Aria.Global.Footer.SoMeList')"
  >
    <template v-for="icon in icons">
      <li
        v-if="icon.link"
        :key="icon.icon"
        class="flex items-center justify-center"
      >
        <a
          class="flex lg:h-8"
          target="_blank"
          rel="noopener noreferrer"
          :href="icon.link"
          :title="icon.title"
          :aria-label="icon.title"
        >
          <BaseIcon
            class="p-1 text-icon"
            :name="icon.icon"
            prefix="social-media"
            fill-color="var(--color-white)"
          />
        </a>
      </li>
    </template>
  </ul>
</template>
